<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
// Overrides @basecom-gmbh/pond/components/Utility/UtilityToastNotification.vue
// IDS-219: change styling (background color, border, etc.)
import type { Notification } from '@shopware-pwa/composables-next';

const { removeOne } = useNotifications();

const props = defineProps<{
    notification: Notification;
}>();

const backgroundMap = {
    info: 'bg-accent-blue-light',
    success: 'bg-accent-green-light',
    warning: 'bg-accent-orange-light',
    danger: 'bg-accent-red-light',
};

const iconBackgroundMap = {
    info: 'bg-accent-blue-dark',
    success: 'bg-accent-green-dark',
    warning: 'bg-accent-orange',
    danger: 'bg-accent-red',
};

const iconMap = {
    info: 'info',
    success: 'check',
    warning: 'triangle-exclamation',
    danger: 'ban',
};

const background = computed(() => backgroundMap[props.notification.type] || 'background-status-info');
const iconBackground = computed(() => iconBackgroundMap[props.notification.type] || 'border-status-info');
const icon = computed(() => iconMap[props.notification.type] || 'information');
</script>

<template>
    <div
        v-if="notification.message.length > 0"
        :id="`toast-${notification.id}`"
        class="flex items-center gap-x-3 p-4"
        role="alert"
        :class="background"
    >
        
<FormKitLazyProvider config-file="true">
<FormKitIcon
            :icon="icon"
            class="text-white block h-6 w-6 shrink-0 rounded-full p-1.5"
            :class="iconBackground"
        />

        <div class="leading-4">
            {{ notification.message }}
        </div>

        <template v-if="!notification.static">
            <button
                type="button"
                class="ml-auto"
                :data-dismiss-target="`toast-${notification.id}`"
                :aria-label="$t('utility.toast.closeButtonAriaLabel')"
                @click="removeOne(notification.id)"
            >
                <FormKitIcon
                    icon="xmark"
                    class="block h-4 w-4 text-gray-dark"
                />
            </button>
        </template>
</FormKitLazyProvider>

    </div>
</template>
